import { notification } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import api from '@utils/api'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const useManualReading = ({
  form,
  store,
  selectedTank,
  setSelectedTank,
  setTankRundownData,
  setDetailStore,
}) => {
  const [showingTankModal, setShowingTankModal] = useState(false)
  const [tankReading, setTankReading] = useState()
  const [manualEntry, setManualEntry] = useState(false)

  useEffect(() => {
    if (!store || !selectedTank) return
    setTankReading(createDefaultReading(store, selectedTank))
  }, [store, selectedTank])

  const closeTankModal = () => {
    setTankReading(createDefaultReading(store, selectedTank))
    form.resetFields()
    setShowingTankModal(false)
  }
  const saveTankReading = (formData, cb) => {
    const date = formData.date.set({
      hour: formData.time.hour(),
      minute: formData.time.minute(),
      second: formData.time.second(),
    })
    const req = {
      store: store.store_number,
      tank: selectedTank.tank_id.toString(),
      date: date.toISOString(),
      inches: formData.inches,
      volume: formData.volume,
    }
    return api.sendManualTankReading(req).then((resp) => {
      if (!resp || !resp.data) return
      setSelectedTank((selectedTank) => ({ ...selectedTank, current_volume: resp.data.inventory, flags: undefined }))
      selectedTank.current_volume = resp.data.inventory
      setTankRundownData(resp.data.tank_rundown)
      setShowingTankModal(false)
      setTankReading(createDefaultReading(store, selectedTank))
      cb()
      notification.success({
        message: 'Manual tank reading saved.',
        description: 'Please wait up to 5 minutes for the system to fully update.',
        duration: 10,
      })
    })
  }
  return {
    tankReading,
    setTankReading,
    saveTankReading,
    closeTankModal,
    manualEntry,
    setManualEntry,
    setShowingTankModal,
    showingTankModal,
  }
}
const createDefaultReading = (store, tank) => {
  const now = moment().local()
  return {
    store: store?.store_number,
    name: store?.name,
    product: tank?.product,
    date: now,
    time: now,
    inches: null,
    gallons: null,
    volume: null,
  }
}
